import React, { useState, useEffect } from 'react';
import '../styles/ErrorNotification.css';

const ErrorNotification = ({ message, onClose, duration = 5000 }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [progress, setProgress] = useState(100);
  
  useEffect(() => {
    // Start the countdown once the component is mounted
    if (!message) {
      setIsVisible(false);
      return;
    }
    
    setIsVisible(true);
    
    // Progress bar animation
    const progressInterval = setInterval(() => {
      setProgress((prev) => {
        if (prev <= 0) {
          clearInterval(progressInterval);
          return 0;
        }
        return prev - (100 / (duration / 100));
      });
    }, 100);
    
    // Auto-dismiss after duration
    const timer = setTimeout(() => {
      setIsVisible(false);
      if (onClose) onClose();
    }, duration);
    
    // Clean up timers
    return () => {
      clearTimeout(timer);
      clearInterval(progressInterval);
    };
  }, [message, duration, onClose]);
  
  if (!message || !isVisible) return null;
  
  return (
    <div className="error-notification">
      <div className="error-content">
        <div className="error-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
        </div>
        <div className="error-message">{message}</div>
        <button className="error-close" onClick={() => {
          setIsVisible(false);
          if (onClose) onClose();
        }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      <div className="error-progress" style={{ width: `${progress}%` }}></div>
    </div>
  );
};

export default ErrorNotification;